module.exports = __webpack_public_path__ + "img/minus.4d5d7ba4.svg";